import styled, { css } from 'styled-components';

export const HistoryContainer = styled.div`
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin-top: 16px;
  width: 100%;
    box-sizing: border-box;

  overflow: hidden;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05);
`;

export const HistoryHeader = styled.div`
  display: grid;
  grid-template-columns: 50px 3fr 2fr 2fr 100px;
  padding: 15px;
  border-bottom: 1px solid #e0e0e0;
  background: #fdfdfd;
  font-weight: 600;
  font-size: 14px;
  color: #333;
  align-items: center;
  & > *:nth-child(1) { justify-self: start; }
  & > *:nth-child(2) { justify-self: start; text-align: left; }
  & > *:nth-child(3) { justify-self: center; text-align: center; }
  & > *:nth-child(4) { justify-self: center; text-align: center; }
  & > *:nth-child(5) { justify-self: center; text-align: center; }
`;

export const HistoryRowWrapper = styled.div`
  border-bottom: 1px solid #f0f0f0;
  background-color: #ffffff;
  &:nth-child(odd) {
    background-color: #FCF6F5; /* Matches SpaceSoft light brown theme tint */
  }
  &:last-child {
    border-bottom: none;
  }
`;

export const HistoryMainRow = styled.div`
  display: grid;
  grid-template-columns: 50px 3fr 2fr 2fr 100px;
  padding: 15px;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: rgba(74, 52, 46, 0.04);
  }
  & > *:nth-child(1) { justify-self: start; display: flex; align-items: center; }
  & > *:nth-child(2) { justify-self: start; text-align: left; }
  & > *:nth-child(3) { justify-self: center; text-align: center; display: flex; flex-direction: column; align-items: center; }
  & > *:nth-child(4) { justify-self: center; display: flex; justify-content: center; }
  & > *:nth-child(5) { justify-self: center; display: flex; justify-content: center; }
`;

export const HistoryContent = styled.div`
  padding: 20px;
  border-top: 1px solid #f0f0f0;
  background: transparent;
`;

export const EvidenceBox = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
  position: relative;
  background: #ffffff;
  &::before {
    position: absolute;
    top: -10px;
    left: 20px;
    background: #fff;
    padding: 0 10px;
    font-size: 14px;
    font-weight: 600;
    color: #333;
  }
`;

export const CircularArrow = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #4a342e; /* Dark brown from SS */
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.3s;
  ${({ expanded }) => expanded && `transform: rotate(180deg);`}
  img {
    width: 10px;
  }
`;
